// extracted by mini-css-extract-plugin
export default {"page-title":"styles_page-title__vp0dJ"};